import script from "./VVVBulkClaimsNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVBulkClaimsNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVBulkClaimsNew.vue?vue&type=style&index=0&id=19956c2c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19956c2c"]])

export default __exports__